import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iqac-aqar-18-19',
  templateUrl: './iqac-aqar-18-19.component.html',
  styleUrls: ['./iqac-aqar-18-19.component.scss']
})
export class IQACAQAR1819Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
